import React, { FC, useContext, useEffect, useState } from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import PoolContext from "../../store/Pool/PoolContext";
import NoDataFound from "../../helpers/NoDataFound";
import Pagination from "../../helpers/Pagination";
import PoolCardClosedMobile from "./PoolCardClosedMobile";
import SkeletonCardClosed from "./PoolsCardSkeletonClosed";


const ClosedPools: FC<any> = ({
    dealPage,
}) => {
    const { closedPools: endedPools, fetchMoreClosedPools, totalClosedPools, isClosedPoolsLoading, closedPoolsError } = useContext<any>(PoolContext);

    const postsPerRow = 3;
    const emptyArray = Array(postsPerRow).fill({});

    const [noData, setNoData] = useState(false);

    useEffect(() => {
        if (endedPools.length <= 0) setNoData(true);
        else setNoData(false);
    }, [endedPools]);

    function handleClickPagination() {
        fetchMoreClosedPools();
    }

    return (
        <>
            <Grid
                container
                spacing={2}
                direction="row"
                style={{
                    marginTop: "10px",
                }}
            >
                <>
                    {
                        closedPoolsError
                        ?
                        (
                            <Box textAlign="center">
                                <Typography variant="h3">
                                    Can't Fetch Data
                                </Typography>
                            </Box>
                        )
                        :
                        (
                            <>
                                {
                                    endedPools
                                    .map((data: any, index: any) => {
                                        const {
                                            id,
                                            slug,
                                            image,
                                            name,
                                            description,
                                            contributionEndDate,
                                            totalCap,
                                            totalRaised,
                                            status,
                                            ath,
                                            networks,
                                            ticker,
                                            distributionScAddress,
                                            poolTokenPrice,
                                        } = data;
                                        return (
                                            <React.Fragment key={index}>
                                                {
                                                    noData
                                                    ?
                                                    (
                                                        <NoDataFound title="No more pools available!" />
                                                    )
                                                    :
                                                    (
                                                        <PoolCardClosedMobile
                                                            key={index}
                                                            id={id}
                                                            slug={slug}
                                                            title={name}
                                                            description={description}
                                                            imgSrc={image}
                                                            progress={false}
                                                            live={contributionEndDate}
                                                            totalCap={totalCap}
                                                            totalRaise={totalRaised}
                                                            endedPool={true}
                                                            token={true}
                                                            status={status}
                                                            ath={ath}
                                                            networks={networks}
                                                            ticker={ticker}
                                                            distributionScAddress={distributionScAddress}
                                                            poolTokenPrice={poolTokenPrice}
                                                        />
                                                    )
                                                }
                                            </React.Fragment>
                                        )
                                    })
                                }
                            </>
                        )
                    }
                </>
            </Grid>
            <Grid
                container
                justifyContent="center"
                spacing={3}
                style={{
                    marginTop: "10px",
                }}
            >
                {
                    isClosedPoolsLoading && (
                        emptyArray.map((i: number) => (
                            <Grid item key={i} lg={4} md={4} sm={6} xs={12}>
                                <SkeletonCardClosed />
                            </Grid>
                        ))
                    )
                }
                {
                    ((endedPools.length < totalClosedPools) || isClosedPoolsLoading) && (
                        <Pagination
                            handleClick={() => handleClickPagination()}
                            isLoading={isClosedPoolsLoading}
                        />
                    )
                }
            </Grid>
        </>
    )
}

export default ClosedPools;